<div style="padding: 15px;">
  <div style="width: 100%;display: flex;justify-content: flex-end;"><mat-icon>power_settings_new</mat-icon>Logout</div>
  <app-payment-plan></app-payment-plan>
</div>